import { Dictionary, UserProfile } from '@feedyou/schema'

import { FeedbotThunk } from '../../../store/types'
import { commentsApi, getFixedCacheKey } from '../api'
import { AuthorId, Comment } from '../types'
import { isCommentValidForSubmitOnServer } from '../utils'
import { openBotIdSelector } from '../../../store/app/selectors'

export const submitNewCommentToServer =
  (comment: Comment, authors: Dictionary<AuthorId, UserProfile>): FeedbotThunk =>
  async (dispatch, getState) => {
    const botId = openBotIdSelector(getState())

    if (!botId) {
      console.error('Missing open bot ID')
      return
    }

    if (!isCommentValidForSubmitOnServer(comment)) {
      throw new Error('You tried to submit a comment which failed to validate.')
    }

    return dispatch(
      commentsApi.endpoints.submitNewComment.initiate(
        { botId, comment, authors },
        { fixedCacheKey: getFixedCacheKey.submitNewComment(comment.id) }
      )
    ).unwrap()
  }
